import React, { useState } from 'react'

import Header from './Header'
import Sidebar from './Sidebar'
import classNames from 'classnames'
import { useMain } from 'src/walliro/hook'
import { useRouteMatch } from 'react-router-dom'
import { ListItemType } from 'src/components/List'
import { SAFE_APP_LANDING_PAGE_ROUTE } from 'src/routes/routes'
import TransactionQueueBar from 'src/components/TransactionQueueBar/TransactionQueueBar'
import { MobileNotSupported } from './MobileNotSupported'

type Props = {
  sidebarItems: ListItemType[]
  safeAddress?: string
  safeName?: string
  balance?: string
  granted: boolean
  onToggleSafeList: () => void
  onReceiveClick: () => void
  onNewTransactionClick: () => void
}
const AppLayout: React.FC<any> = ({
  balance,
  safeAddress,
  safeName,
  granted,
  onToggleSafeList,
  onReceiveClick,
  onNewTransactionClick,
  children,
  sidebarItems,
}): React.ReactElement => {
  const [mobileNotSupportedClosed, setMobileNotSupportedClosed] = useState(false)
  const closeMobileNotSupported = () => setMobileNotSupportedClosed(true)

  const { sidebar } = useMain()
  const showSideBar = !useRouteMatch({ path: SAFE_APP_LANDING_PAGE_ROUTE })

  return (
    <div className="h-100">
      {showSideBar && !!safeAddress && (
        <aside>
          <Sidebar
            items={sidebarItems}
            safeAddress={safeAddress}
            safeName={safeName}
            balance={balance}
            granted={granted}
            onToggleSafeList={onToggleSafeList}
            onReceiveClick={onReceiveClick}
            onNewTransactionClick={onNewTransactionClick}
          />
        </aside>
      )}
      <div className={classNames('wrapper-main', { close: !sidebar.open || !safeAddress }, { 'ps-0': !safeAddress })}>
        <Header balance={balance} onToggleSafeList={onToggleSafeList} />
        <main className="flex-grow-1 flex-basis-0 pt-3 overflow-auto">
          {children}
          <TransactionQueueBar />
        </main>
      </div>
    </div>
  )
}

export default AppLayout
